<template>
    <div class="spo-card pa-2 rounded my-2 bordered">

        <div id="preinscriptions_gauge"></div>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { usePreInscriptionMaxiraceStore } from "@/stores/specific/preInscriptionMaxirace";
import Highcharts from "highcharts";

export default {
    data() {

    },
    computed: {
        ...mapStores(usePreInscriptionMaxiraceStore),
        gauge_xaxis() {
            return this.preInscriptionMaxiraceStore.gauge_xaxis;
        },
        series_validated() {
            return this.preInscriptionMaxiraceStore.series_validated;
        },
        series_pending() {
            return this.preInscriptionMaxiraceStore.series_pending;
        },
        series_selected() {
            return this.preInscriptionMaxiraceStore.series_selected;
        },
        unique_inscriptions_flagged() {
            return this.preInscriptionMaxiraceStore.unique_inscriptions_flagged;
        },
        nb_inscrits_courses_flagged() {
            return this.preInscriptionMaxiraceStore.nb_inscrits_courses_flagged;
        },
        nb_inscrits_options_flagged() {
            return this.preInscriptionMaxiraceStore.nb_inscrits_options_flagged;
        }
    },
    watch: {
        'preInscriptionMaxiraceStore.selection': {
            handler() {
                this.$nextTick(() => {
                    this.buildGauge();
                });
            },
            immediate: true
        }
    },
    mounted() {
        this.$nextTick(() => {

            this.buildGauge();
        });
    },
    methods: {

        buildGauge() {
            // Vérifier que le conteneur existe et que nous avons des données
            if (!document.getElementById('preinscriptions_gauge') || !this.preInscriptionMaxiraceStore.selection) {
                return;
            }

            Highcharts.chart('preinscriptions_gauge', {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: '',
                    align: 'left'
                },
                xAxis: {
                    categories: this.gauge_xaxis
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: ''
                    },
                    stackLabels: {
                        enabled: true,
                        formatter: function () {
                            return "Total: " + this.total;
                        },
                        style: {
                            fontWeight: 'bold',
                            color: '#000000',
                            fontSize: '12px',

                        }
                    }
                },
                legend: {
                    reversed: true
                },
                plotOptions: {
                    series: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                series: [
                    {
                        name: 'Dans la sélection courante',
                        data: this.series_selected,
                        color: '#0041b0'
                    }, {
                        name: 'Inscriptions en attente d\'encaissement',
                        data: this.series_pending,
                        color: '#b09000'
                    },
                    {
                        name: 'Inscriptions validées',
                        data: this.series_validated,
                        color: '#026b2e'
                    }]
            });
        }
    }

}
</script>

<style lang="scss" scoped></style>